import { render, staticRenderFns } from "./page_size_selector.vue?vue&type=template&id=f52a6af8"
import script from "./page_size_selector.vue?vue&type=script&lang=js"
export * from "./page_size_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports